import useQuestionLogic from './useQuestionLogic'

export default useQuestionLogic
